var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import { Map, Markers } from "../../Map";
import { TemplateLabel } from "../../Layout";
import {
  getAndSelectDocument,
  selectDocuments,
  unselectAllDocuments } from "../../Library/actions/libraryActions";

import { wrapDispatch } from "../../Multireducer";

import { Loader } from "../../components/Elements/Loader";
import markdownDatasets from "../markdownDatasets";

const renderInfo = (marker) => /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx(TemplateLabel, { template: marker.properties.entity.template }), "\xA0 ",
marker.properties.entity.title
);


export const MapComponent = (props) => {
  const { data, classname, scrollZoom, showControls, zoom = 6 } = props;
  const clickOnMarker = (marker) => props.getAndSelectDocument(marker.properties.entity.sharedId);
  const clickOnCluster = (cluster) => {
    props.unselectAllDocuments();
    props.selectDocuments(cluster.map((m) => m.properties.entity));
  };
  return (/*#__PURE__*/
    _jsx("div", { className: `Map ${classname}` }, void 0,
    data ? /*#__PURE__*/
    _jsx(Markers, { entities: data }, void 0,
    (markers) => /*#__PURE__*/
    _jsx(Map, {
      markers: markers,
      zoom: parseInt(zoom, 10),
      clickOnMarker: clickOnMarker,
      clickOnCluster: clickOnCluster,
      renderPopupInfo: renderInfo,
      cluster: true,
      scrollZoom: scrollZoom === 'true',
      showControls: showControls === 'true' }
    )

    ) : /*#__PURE__*/

    _jsx(Loader, {})

    ));

};

MapComponent.defaultProps = {
  classname: '',
  data: null,
  scrollZoom: null,
  showControls: null
};












export const mapStateToProps = (state, props) => ({
  data: markdownDatasets.getRows(state, props)
});

export const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  { getAndSelectDocument, selectDocuments, unselectAllDocuments },
  wrapDispatch(dispatch, 'library')
);

export default connect(mapStateToProps, mapDispatchToProps, null)(MapComponent);